import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Container,
  Box,
} from "@mui/material";
import { useJobConfigurationContext } from "../../../../contexts/JobConfigurationContext";

function ConfigurationDialogBase({ children }) {
  const handleClose = () => {
    setActiveJob(null);
  };
  const { activeJob, setActiveJob, handleSave, error } =
    useJobConfigurationContext();

  return (
    <Dialog open={!!activeJob}
    sx={{
      overflow: "hidden", // No scrolling
      "& .MuiDialog-paper": { maxWidth: "35vw", width: "35vw" }, // Ensures the entire dialog is within 35vw
    }}
  >
    <DialogTitle variant="h3">Configure {activeJob?.name}</DialogTitle>
    <DialogContent
      sx={{
        width: "35vw",
        maxWidth: "35vw", // Ensure it never exceeds 35vw
        height: "50vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch", // Ensures children respect width
        overflow: "hidden", // Prevent scrolling
        boxSizing: "border-box", // Prevents padding from affecting width
        p: 2,
      }}
    >
      <Box
        sx={{
          width: "100%", // Forces children to stay within the container
          maxWidth: "100%", // Prevents overflow
          overflow: "hidden", // No unwanted scrolling
          boxSizing: "border-box", // Ensures padding doesn't expand width
        }}
      >
        {children}
      </Box>
    </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSave}>Save</Button>
      </DialogActions>
      {error && (
        <Typography variant="body2" color="error" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </Dialog>
  );
}

export default ConfigurationDialogBase;
